import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ImageContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(({ isDisable }) => ({
  width: '128px',
  height: '72px',
  cursor: isDisable ? 'not-allowed' : 'pointer'
}));

export const ImageStyled = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 12
}));

export const BoxStyled = styled(ImageContainerStyled, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(({ theme, isDisable }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 14px',
  border: `2px dashed ${theme.palette.border.main}`,
  borderRadius: 12,
  cursor: isDisable ? 'not-allowed' : 'pointer'
}));

export const TakePhotoLabelStyle = () => ({
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 600
});

export const CapturedImageWrapperStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isDisable'
})(({ isDisable }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: isDisable ? 0.5 : 1,
  pointerEvents: isDisable ? 'none' : 'auto'
}));
